import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Lista de rotas públicas que não devem ser salvas como última rota.
// A raiz também fica de fora: ela só redireciona para a última tela usada.
const PUBLIC_ROUTES = ['/', '/signin', '/signup', '/reset-password'];

export function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (!PUBLIC_ROUTES.includes(location.pathname)) {
      localStorage.setItem('lastRoute', location.pathname);
    }
  }, [location]);
  return null;
} 